import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { InjectionToken, ɵɵdefineInjectable, ɵɵinject, Injectable, NgZone, Injector, INJECTOR } from '@angular/core';
import { NotificationsService } from '@mt-ng2/notifications-module';
import { ModalService } from '@mt-ng2/modal-module';
import { AuthService } from '@mt-ng2/auth-module';

/**
 * Token used for providing the IErrorsModuleConfig
 * @example
 * // in the app or shared modules providers section
 * providers: [
 *     { provide: ErrorsModuleConfigToken, useValue: errorsModuleConfig },
 * ],
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
const ErrorsModuleConfigToken = new InjectionToken('errors_module_config');

function IsToastableErrorGuard(object) {
    // helper function to check if error is of type IToastableError
    return 'errorMessage' in object && 'notificationType' in object;
}

var NotificationTypes;
(function (NotificationTypes) {
    NotificationTypes[NotificationTypes["Error"] = 0] = "Error";
    NotificationTypes[NotificationTypes["Success"] = 1] = "Success";
    NotificationTypes[NotificationTypes["Warning"] = 2] = "Warning";
    NotificationTypes[NotificationTypes["Info"] = 3] = "Info";
})(NotificationTypes || (NotificationTypes = {}));

class ConcurrencyService {
    constructor(http) {
        this.http = http;
    }
    overWriteEntity(error) {
        return this.http.put(error.originalError.url, error.formObject);
    }
}
ConcurrencyService.ɵfac = function ConcurrencyService_Factory(t) { return new (t || ConcurrencyService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient)); };
ConcurrencyService.ɵprov = ɵɵdefineInjectable({ factory: function ConcurrencyService_Factory() { return new ConcurrencyService(ɵɵinject(HttpClient)); }, token: ConcurrencyService, providedIn: "root" });
ConcurrencyService.ctorParameters = () => [
    { type: HttpClient }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ConcurrencyService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.HttpClient }]; }, null); })();

class GlobalErrorHandler {
    constructor(injector) {
        this.injector = injector;
        this.config = {
            customErrorHandlerFunction: (this.errorsModuleConfig && this.errorsModuleConfig.customErrorHandlerFunction) || null,
            loginErrorMessage: (this.errorsModuleConfig && this.errorsModuleConfig.loginErrorMessage) || `I've got a bad feeling about this.  Please re-login.`,
            serviceUnavailableMessage: (this.errorsModuleConfig && this.errorsModuleConfig.serviceUnavailableMessage) ||
                `Application is unavailable, please try again in a few minutes`,
            unhandledErrorMessage: (this.errorsModuleConfig && this.errorsModuleConfig.unhandledErrorMessage) || `An unhandled error has occurred.`,
        };
    }
    get concurrencyService() {
        return this.injector.get(ConcurrencyService);
    }
    get errorsModuleConfig() {
        return this.injector.get(ErrorsModuleConfigToken, null);
    }
    get modalService() {
        return this.injector.get(ModalService);
    }
    get zone() {
        return this.injector.get(NgZone);
    }
    handleError(error) {
        if (!this.notificationsService) {
            this.notificationsService = this.injector.get(NotificationsService);
        }
        const toastroptions = {
            enableHtml: true,
            preventDuplicates: true,
            preventOpenDuplicates: true,
        };
        console.log(error);
        if (this.config.customErrorHandlerFunction) {
            const toastableError = this.config.customErrorHandlerFunction(error);
            if (toastableError && IsToastableErrorGuard(toastableError)) {
                // check if toastableError is of interface IToastableError
                switch (toastableError.notificationType) {
                    case NotificationTypes.Info:
                        this.notificationsService.info(toastableError.errorMessage);
                        return;
                    case NotificationTypes.Warning:
                        this.notificationsService.warning(toastableError.errorMessage);
                        return;
                    case NotificationTypes.Success:
                        this.notificationsService.success(toastableError.errorMessage);
                        return;
                    case NotificationTypes.Error:
                    default:
                        this.notificationsService.error(toastableError.errorMessage);
                        return;
                }
            }
        }
        if (error.originalError instanceof HttpErrorResponse && error.originalError.status === 401) {
            // Using an Object.Assign to load both error options.
            // This loads the Ionic and Portal(toastrOptions).
            // The Notification strategies handle parsing them out correctly
            this.notificationsService.error(this.config.loginErrorMessage, 'Error', Object.assign({
                header: 'Error',
            }, toastroptions));
        }
        else if (error.originalError instanceof HttpErrorResponse && error.originalError.status === 409) {
            // Handle Concurrency
            const concurrencyModalOptions = {
                cancelButtonClass: 'btn btn-swal-override',
                cancelButtonText: 'Update',
                confirmButtonClass: 'btn btn-swal-override',
                confirmButtonText: 'Overwrite',
                showCancelButton: true,
                text: 'Would you like to reload with the updated data or overwrite with your changes?',
                title: 'Someone else has changed the data since you made your changes.',
                type: 'warning',
            };
            this.modalService.showModal(concurrencyModalOptions).subscribe((result) => {
                if (result.value) {
                    const version = error.originalError.error.Version;
                    error.formObject.Version = version;
                    this.zone.runGuarded(() => {
                        this.overWrite(error);
                    });
                }
                else if (result.dismiss) {
                    window.location.reload();
                }
            });
        }
        else if (error.originalError instanceof HttpErrorResponse && error.originalError.status === 503) {
            // Using an Object.Assign to load both error options.
            // This loads the Ionic and Portal(toastrOptions).
            // The Notification strategies handle parsing them out correctly
            this.notificationsService.info(this.config.serviceUnavailableMessage, Object.assign({
                header: 'Info',
            }, toastroptions));
        }
        else if (error && error.status && error.status === 503) {
            // Using an Object.Assign to load both error options.
            // This loads the Ionic and Portal(toastrOptions).
            // The Notification strategies handle parsing them out correctly
            this.notificationsService.info(this.config.serviceUnavailableMessage, Object.assign({
                header: 'Info',
            }, toastroptions));
        }
        else if (error.error && error.error.ModelState) {
            // Handle Model State Errors
            let errString = '';
            let modelErrors = Object.keys(error.error.ModelState).map((key) => {
                return error.error.ModelState[key];
            });
            modelErrors.forEach((err) => {
                // The validators throw line breaks in between, but toast prefers br tags
                err = err.toString().replace(/(\r\n|\n|\r)/g, '<br />');
                errString += err;
            });
            this.notificationsService.error(errString, 'Error', Object.assign({
                header: 'Error',
            }, toastroptions));
        }
        else {
            // Catch All
            this.notificationsService.error(this.config.unhandledErrorMessage, 'Error', Object.assign({
                header: 'Error',
            }, toastroptions));
        }
    }
    overWrite(error) {
        this.concurrencyService.overWriteEntity(error).subscribe(() => {
            this.notificationsService.success('Overwritten Successfully', {
                onHidden: function () {
                    window.location.reload();
                },
                timeOut: 1500,
            });
        }, () => {
            this.notificationsService.error('Failed to overwrite.');
        });
    }
}

class AppError {
    constructor(originalError, formObject) {
        this.originalError = originalError;
        this.formObject = formObject;
    }
}

class BadRequestError extends AppError {
}

class NotFoundError extends AppError {
}

class BreckErrorHandler extends GlobalErrorHandler {
    constructor(injector) {
        super(injector);
        this.injector = injector;
    }
}
BreckErrorHandler.ɵfac = function BreckErrorHandler_Factory(t) { return new (t || BreckErrorHandler)(ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
BreckErrorHandler.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: BreckErrorHandler, factory: BreckErrorHandler.ɵfac });
BreckErrorHandler.ctorParameters = () => [
    { type: Injector }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BreckErrorHandler, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

class CurrentUserService {
    constructor(injector) {
        this.injector = injector;
    }
    get errorsModuleConfig() {
        return this.injector.get(ErrorsModuleConfigToken, null);
    }
    get authService() {
        return this.injector.get(AuthService);
    }
    getCurrentUser() {
        if (this.errorsModuleConfig && this.errorsModuleConfig.getCurrentUserOverrideFunction) {
            return this.errorsModuleConfig.getCurrentUserOverrideFunction();
        }
        return this.authService.currentUser.getValue();
    }
}
CurrentUserService.ɵfac = function CurrentUserService_Factory(t) { return new (t || CurrentUserService)(ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
CurrentUserService.ɵprov = ɵɵdefineInjectable({ factory: function CurrentUserService_Factory() { return new CurrentUserService(ɵɵinject(INJECTOR)); }, token: CurrentUserService, providedIn: "root" });
CurrentUserService.ctorParameters = () => [
    { type: Injector }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CurrentUserService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { AppError, BadRequestError, BreckErrorHandler, ConcurrencyService, CurrentUserService, ErrorsModuleConfigToken, GlobalErrorHandler, IsToastableErrorGuard, NotFoundError, NotificationTypes };

//# sourceMappingURL=mt-ng2-errors-module.js.map